import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Input, notification, Layout, Row, Col } from 'antd';
import { LockOutlined, LoginOutlined, UserOutlined } from "@ant-design/icons";

import { loginAction, LoginData } from 'store/auth/auth.actions';
import { ROLES } from 'constants/roles';
import ROUTES from 'constants/routes';
import { useAppDispatch, useAppSelector } from 'store';
import { tokenInfoSelector } from 'store/auth/auth.selectors';
import styles from './Login.module.scss';

const Login: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const tokenInfo = useAppSelector(tokenInfoSelector);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (!tokenInfo) return;
    if (tokenInfo.roles?.includes(ROLES.ROLE_ADMIN)) {
      return navigate(ROUTES.ADMINISTRATION);
    }
    navigate(ROUTES.DISTRIBUTION);
  }, [tokenInfo]);

  const onFinish = (values: LoginData) => {
    setLoading(true);
    dispatch(loginAction(values))
      .catch((e: any) => {
        if (e.code === 401 && e.message === 'Invalid credentials.') {
          form.setFields([{
            name: 'username',
            errors: ['']
          }, {
            name: 'password',
            errors: ['Неверный логин или пароль']
          }]);
        } else {
          notification.error({ message: e?.message || e });
        }
      })
      .finally(() => setLoading(false));
  };

  return (
    <Layout className={styles.wrapper}>
      <Form form={form} onFinish={onFinish} className={styles.form}>
        <Form.Item
          name="username"
          rules={[
            {
              required: true,
              message: 'Пожалуйста, введите ваш E-mail'
            },
            {
              type: "email",
              message: 'Неверный формат почты'
            }
          ]}
        >
          <Input
            prefix={<UserOutlined />}
            placeholder="E-mail"
          />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[{ required: true, message: 'Пожалуйста, введите ваш пароль' }]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="Пароль"
          />
        </Form.Item>
        <Row justify="end">
          <Col>
            <Button
              icon={<LoginOutlined />}
              type="primary"
              loading={loading}
              htmlType="submit"
            >
              Войти
            </Button>
          </Col>
        </Row>
      </Form>
    </Layout>
  );
};

export default Login;
